import { useEffect } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { useFeatureFlags } from "@/contexts/FeatureFlagContext";
import { useIsSystemAdmin } from "@/hooks/useIsSystemAdmin";
import { useIsTenantAdmin } from "@/hooks/useIsTenantAdmin";
import {
  recordMeticulousCustomContext,
  recordMeticulousFeatureFlags,
  recordMeticulousUser,
} from ".";

export const MeticulousSessionRecorder = () => {
  const { authUser } = useAuth();
  const { features } = useFeatureFlags();
  const { isSystemAdmin, isLoading: isSystemAdminLoading } = useIsSystemAdmin();
  const { isTenantAdmin, isLoading: isTenantAdminLoading } = useIsTenantAdmin();

  useEffect(() => {
    if (authUser) recordMeticulousUser(authUser);
  }, [authUser]);

  useEffect(() => {
    recordMeticulousFeatureFlags(features);
  }, [features]);

  useEffect(() => {
    if (isSystemAdminLoading || isTenantAdminLoading) return;
    recordMeticulousCustomContext("isSystemAdmin", isSystemAdmin);
    recordMeticulousCustomContext("isTenantAdmin", isTenantAdmin);
  }, [
    isSystemAdmin,
    isTenantAdmin,
    isSystemAdminLoading,
    isTenantAdminLoading,
  ]);

  return null;
};
